import React from "react";
import { Box, CircularProgress, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import PublishIcon from "@mui/icons-material/Publish";
import { PrimaryButton } from "../../../shared/buttons/PrimaryButton.styled";
import type { QtoSummary } from "./qtoSummary";

interface TakeOffActionsButtonsProps {
  summary: QtoSummary;
}

const TakeOffActionsButtons: React.FC<TakeOffActionsButtonsProps> = ({ summary }) => {
  const { reviewDisabled, reviewTooltip, submitDisabled, isExporting, isSubmitting, handleReview, handleSubmit } =
    summary;

  return (
    <Box sx={{ display: "flex", gap: "4px" }}>
      <Tooltip title={reviewDisabled ? reviewTooltip : ""}>
        <Box component="span" sx={{ display: "inline-flex" }}>
          <PrimaryButton
            onClick={() => void handleReview()}
            disabled={reviewDisabled}
            startIcon={isExporting ? <CircularProgress size={12} color="inherit" /> : <EditIcon />}
          >
            {isExporting ? "Creating..." : "Review"}
          </PrimaryButton>
        </Box>
      </Tooltip>
      <PrimaryButton
        onClick={() => void handleSubmit()}
        disabled={submitDisabled}
        startIcon={isSubmitting ? <CircularProgress size={12} color="inherit" /> : <PublishIcon />}
      >
        {isSubmitting ? "Submitting..." : "Submit to Estimate"}
      </PrimaryButton>
    </Box>
  );
};

export default TakeOffActionsButtons;
